import { Box, Button, Chip, Stack, Typography } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import { useNavigate } from "react-router-dom";
import { DashboardAnalytics, InventoryAnalytics } from "../Dashboard.types";

interface DashboardHeaderProps {
  onRefresh: () => void;
  dashboard?: DashboardAnalytics;
  inventory?: InventoryAnalytics;
}

const DashboardHeader = ({ onRefresh, dashboard, inventory }: DashboardHeaderProps) => {
  const navigate = useNavigate();
  const available = inventory?.availableStock ?? dashboard?.availableStock ?? 0;
  const total = inventory?.totalStock ?? dashboard?.totalStock ?? 0;

  return (
    <Stack
      direction={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      alignItems={{ xs: "stretch", lg: "center" }}
      spacing={2}
      sx={{
        pb: 1.5,
        borderBottom: "1px solid",
        borderColor: "divider",
        color: "text.primary",
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ minWidth: 0 }}>
        <Box sx={{ width: 40, height: 40, display: "grid", placeItems: "center", flexShrink: 0, borderRadius: 1.75, color: "common.white", bgcolor: "primary.main", boxShadow: "0 8px 16px rgba(37,99,235,.22)" }}><Inventory2OutlinedIcon fontSize="small" /></Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="overline" color="primary.main" fontWeight={850} sx={{ lineHeight: 1, letterSpacing: 1.1 }}>SPARE PARTS CONTROL DESK</Typography>
          <Typography variant="h5" fontWeight={850} sx={{ mt: .15 }}>Operations at a glance</Typography>
          <Typography variant="caption" color="text.secondary" sx={{ mt: .2, display: "block" }}>Inventory health, purchase activity, service spares, and warehouse attention in one place.</Typography>
        </Box>
      </Stack>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ xs: "stretch", sm: "center" }}>
        <Chip label={`${available.toLocaleString()} of ${total.toLocaleString()} units available`} color="success" variant="outlined" sx={{ justifyContent: "center" }} />
        <Button
          variant="outlined"
          startIcon={<RefreshIcon />}
          onClick={onRefresh}
        >
          Refresh
        </Button>

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate("/spare-parts/master?create=1")}
        >
          Add Spare Part
        </Button>
      </Stack>
    </Stack>
  );
};

export default DashboardHeader;
